module.exports = __webpack_public_path__ + "static/media/tj.09418f13.svg";